import axios from '../../config/axios';

export const home = {
  namespaced: true,
  state: {
    // loading: false,
    // homeData: {},
    voucherStat: {},
    homeProgress: {},
    homeInvite: {},
    homeMission: {},
    homeReward: {},
    homeBox: {},
    loadingCoin: false,
    loadingProgress: false,
    loadingInvite: false,
    loadingMission: false,
    loadingReward: false,
    loadingBox: false,
  },
  getters: {
  },
  mutations: {
    // SET_LOADING (state, payload) {
    //   state.loading = payload
    // },
    SET_HOME_VOUCHER(state, payload) {
      state.voucherStat = payload;
    },
    SET_HOME_PROGRESS(state, payload) {
      state.homeProgress = payload;
    },
    SET_HOME_INVITE(state, payload) {
      state.homeInvite = payload;
    },
    SET_HOME_MISSION(state, payload) {
      state.homeMission = payload;
    },
    SET_HOME_REWARD(state, payload) {
      state.homeReward = payload;
    },
    SET_HOME_BOX(state, payload) {
      state.homeBox = payload;
    },
    SET_LOADING_COIN(state, payload) {
      state.loadingCoin = payload;
    },
    SET_LOADING_PROGRESS(state, payload) {
      state.loadingProgress = payload;
    },
    SET_LOADING_INVITE(state, payload) {
      state.loadingInvite = payload;
    },
    SET_LOADING_MISSION(state, payload) {
      state.loadingMission = payload;
    },
    SET_LOADING_REWARD(state, payload) {
      state.loadingReward = payload;
    },
    SET_LOADING_BOX(state, payload) {
      state.loadingBox = payload;
    },
  },
  actions: {
    getHomeCoin({ commit, dispatch }, payload) {
      commit('SET_LOADING_COIN', true);
      axios({
        url: '/api/user/profile',
        method: 'get',
        headers: {
          Authorization: payload,
        },
      })
        .then(({ data }) => {
          // console.log(data)
          dispatch('global/setCoin', data.data.coin, { root: true });
          dispatch('global/setVoucher', data.data.count_my_voucher, { root: true });
          dispatch('global/setExpiredCoin', data.data.expire_date_coin, { root: true });
          commit('SET_LOADING_COIN', false);
          // commit('SET_LOADING', false)
        })
        .catch((err) => {
          dispatch('global/setError', { status: true, err }, { root: true });
          dispatch('global/setLoading', false, { root: true });
          // commit('SET_LOADING', false)
        });
    },
    getHomeVoucher({ commit, dispatch }, payload) {
      axios({
        url: '/api/user/home/voucher-status',
        method: 'get',
        headers: {
          Authorization: payload,
        },
      })
        .then(({ data }) => {
          // console.log(data)
          commit('SET_HOME_VOUCHER', data.data);
          // commit('SET_LOADING', false)
        })
        .catch((err) => {
          dispatch('global/setError', { status: true, err }, { root: true });
          dispatch('global/setLoading', false, { root: true });
          // commit('SET_LOADING', false)
        });
    },
    getHomeProgress({ commit, dispatch }, payload) {
      commit('SET_LOADING_PROGRESS', true);
      axios({
        url: '/api/user/home/transaction-mission',
        method: 'get',
        headers: {
          Authorization: payload,
        },
      })
        .then(({ data }) => {
          // console.log(data)
          commit('SET_HOME_PROGRESS', data.data);
          commit('SET_LOADING_PROGRESS', false);
          // commit('SET_LOADING', false)
        })
        .catch((err) => {
          dispatch('global/setError', { status: true, err }, { root: true });
          dispatch('global/setLoading', false, { root: true });
          // commit('SET_LOADING', false)
        });
    },
    getHomeInvite({ commit, dispatch }, payload) {
      commit('SET_LOADING_INVITE', true);
      axios({
        url: '/api/user/home/referral',
        method: 'get',
        headers: {
          Authorization: payload,
        },
      })
        .then(({ data }) => {
          // console.log(data)
          commit('SET_HOME_INVITE', data.data);
          commit('SET_LOADING_INVITE', false);
          // commit('SET_LOADING', false)
        })
        .catch((err) => {
          dispatch('global/setError', { status: true, err }, { root: true });
          dispatch('global/setLoading', false, { root: true });
          // commit('SET_LOADING', false)
        });
    },
    getHomeMission({ commit, dispatch }, payload) {
      commit('SET_LOADING_MISSION', true);
      axios({
        url: '/api/user/home/mission',
        method: 'get',
        headers: {
          Authorization: payload,
        },
      })
        .then(({ data }) => {
          // console.log(data)
          commit('SET_HOME_MISSION', data.data);
          commit('SET_LOADING_MISSION', false);
          // commit('SET_LOADING', false)
        })
        .catch((err) => {
          dispatch('global/setError', { status: true, err }, { root: true });
          dispatch('global/setLoading', false, { root: true });
          // commit('SET_LOADING', false)
        });
    },
    getHomeReward({ commit, dispatch }, payload) {
      commit('SET_LOADING_REWARD', true);
      axios({
        url: '/api/user/home/gift-recommendation',
        method: 'get',
        headers: {
          Authorization: payload,
        },
      })
        .then(({ data }) => {
          // console.log(data)
          commit('SET_HOME_REWARD', data.data);
          commit('SET_LOADING_REWARD', false);
          // commit('SET_LOADING', false)
        })
        .catch((err) => {
          dispatch('global/setError', { status: true, err }, { root: true });
          dispatch('global/setLoading', false, { root: true });
          // commit('SET_LOADING', false)
        });
    },
    getHomeBox({ commit, dispatch }, payload) {
      commit('SET_LOADING_BOX', true);
      axios({
        url: '/api/user/home/treasury-box',
        method: 'get',
        headers: {
          Authorization: payload,
        },
      })
        .then(({ data }) => {
          // console.log(data)
          commit('SET_HOME_BOX', data.data);
          commit('SET_LOADING_BOX', false);
          // commit('SET_LOADING', false)
        })
        .catch((err) => {
          dispatch('global/setError', { status: true, err }, { root: true });
          dispatch('global/setLoading', false, { root: true });
          // commit('SET_LOADING', false)
        });
    },
  },
};
